/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const ExcelLearnMoreActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.LearnMore,
    checked: false,
    primaryContent: strings.getString('trialconversionExcelLearnMoreHeader'),
    secondaryContent: strings.getString('trialconversionExcelLearnMoreContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionExcelCard', 'Learn more clicked'),
    retriggerable: true
});
